export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5284.47ff5882.jpg";